import { FilterType } from '@/types/asset-search.types';
import { isAssetsResponse } from '@repo/types/asset';

import { getServiceEndpoint } from '@/api/helpers.api';
import { fetcher } from '@/utils/fetch.utils';
import { getAppConfig } from '@/utils/window.utils';

import { AssetRetrievalError } from './asset-retrieval-error.api';

const API_FILTER_QUERY_PARAM_NAME = {
    [FilterType.NoOfDays]: FilterType.NoOfDays,
    [FilterType.AssetId]: 'orderId',
} satisfies Record<AssetFilterQueryParam['name'], string>;

export const getAssets = async (filters: AssetFilterQueryParam[]) => {
    const config = getAppConfig();

    let queryString = '?';
    if (filters.length > 0) {
        for (const filter of filters) {
            if (!filter.value) {
                continue;
            }
            queryString += `${API_FILTER_QUERY_PARAM_NAME[filter.name]}=${filter.value}&`;
        }
        queryString = queryString.slice(0, -1);
    }

    const url = `${getServiceEndpoint(config.api.services.orderTaking, 'getAssets')}${queryString}`;

    const req = await fetcher(url);
    if (req.status === 204) {
        return { assets: [], errors: [] };
    }

    const data = await req.json();
    return isAssetsResponse(data) ? data : Promise.reject(new AssetRetrievalError());
};

export interface AssetFilterQueryParam {
    name: typeof FilterType.NoOfDays | typeof FilterType.AssetId;
    value: string | null;
}
